import apiClient from './apiClient'

export const getResellerOrders = async (criteria) => await apiClient.get('/api/ResellerOrders', criteria)
export const deleteResellerOrder = async (id, payload) => await apiClient.delete(`/api/ResellerOrders/${id}`, payload)
export const putResellerOrder = async (id, payload) => await apiClient.put(`/api/ResellerOrders/${id}`, payload)
